import { withDefaults } from '@warp-drive/legacy/model/migration-support';

// prettier-ignore
const TasAssetSchema = withDefaults({
  'type': 'tas-asset',
  objectExtensions: ['tas-asset', 'digital-asset'],
  'traits': ['digital-asset'],
  'fields': [
    {
      'kind': 'hasMany',
      'name': 'tasProgramInstances',
      'type': 'tas-program-instance',
      'options': {
        'async': false,
        'inverse': 'tasAssets'
      }
    },
    {
      'kind': 'hasMany',
      'name': 'tasApplications',
      'type': 'tas-application',
      'options': {
        'async': false,
        'inverse': 'tasAssets'
      }
    },
    {
      'kind': 'hasMany',
      'name': 'tasCourses',
      'type': 'tas-course',
      'options': {
        'async': false,
        'inverse': 'tasAssets'
      }
    },
    {
      'kind': 'hasMany',
      'name': 'tasAssistances',
      'type': 'tas-assistance',
      'options': {
        'async': false,
        'inverse': 'tasAssets'
      }
    }
  ]
});

export default TasAssetSchema;
